import { Directive, HostListener, Input, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';
import { stripPhone, formatPhone } from '../utils/phone.util';

@Directive({
  selector: '[appPhoneInput]',
  standalone: true,
})
export class PhoneInputDirective {
  @Input('appPhoneInput') formatOnBlur = true;

  constructor(private el: ElementRef<HTMLInputElement>, private controlDir: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(e: Event) {
    const input = this.el.nativeElement;
    const digits = stripPhone(input.value);
    input.value = digits;
    if (this.controlDir && this.controlDir.control) {
      this.controlDir.control.setValue(digits, { emitEvent: true });
    }
  }

  @HostListener('blur')
  onBlur() {
    if (!this.formatOnBlur) return;
    const input = this.el.nativeElement;
    const digits = stripPhone(input.value);
    input.value = formatPhone(digits);
    if (this.controlDir && this.controlDir.control) {
      this.controlDir.control.setValue(digits, { emitEvent: true });
    }
  }
}
